export { CollapsibleItem, type CollapsibleItemProps } from "./CollapsibleItem";
